import "./Logistics.module.css";
import Header from "@/reusable_sections/Header";
import LogisticsOverview from "./sections/LogisticsOverview";
import DeliveryProcess from "./sections/DeliveryProcess";
import NightTransportBenefits from "./sections/NightTransportBenefits";
import Footer from "@/reusable_sections/Footer";
export default function LogisticsPage() {
  return <div>
      <Header />
      <LogisticsOverview />
      <DeliveryProcess />
      <NightTransportBenefits />
      <Footer />
    </div>;
}